import { useState } from "react";
import Icon from "../../../UI/Icon/Icon";
import classes from "./LanguageSwitcher.module.scss";

// const LANGUAGES = [];

const LanguageSwitcher = () => {
  const [showMenu, setShowMenu] = useState(false);

  const toggleMenu = () => {
    setShowMenu((oldState) => !oldState);
  };

  return (
    <div onClick={toggleMenu} className={classes.LanguageSwitcher}>
      <button>
        <Icon name="flag-us" width={1.6} height={1.2} />
        <span>ENG</span>
        <Icon name="chevron-down" width={1.6} height={1.6} />
      </button>
      {showMenu && (
        <ul>
          <li>
            <Icon name="flag-us" width={1.6} height={1.2} />
            <span>ENG</span>
          </li>
        </ul>
      )}
    </div>
  );
};

export default LanguageSwitcher;
